import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PlycaUiButtonGenericComponent } from '@plyca/ui-library/components/atoms/buttons/button-generic/button-generic.component';
import { PlycaUiFilterPanelComponent } from '@plyca/ui-library/components/organisms/filters/filter-panel/filter-panel.component';
import { BaseComponent } from '@/app/components/common/baseComponent/base.component';
import { isModified } from '@/app/_infrastructure/utils/comparison/comparison.utils';
import { FormConfig } from '@/app/components/forms/form.objects';
import { UserService } from '@/app/user.service';
import { FilterPanelDemoData, FilterPanelDemoDTO } from './_config/filter-panel-demo.model';

@Component({
  selector: 'plyca-ui-filter-panel-demo',
  templateUrl: './filter-panel-demo.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiFilterPanelComponent, PlycaUiButtonGenericComponent, TranslateModule]
})
export class FilterPanelDemoComponent extends BaseComponent implements OnDestroy {
  public isSearchButtonEnabled: Signal<boolean> = computed(() => false);

  public model: FilterPanelDemoDTO = new FilterPanelDemoDTO();
  public dataModelOnChange: FilterPanelDemoData;
  public formConfigFilters: FormConfig;

  private readonly _userService = inject(UserService);

  constructor() {
    super();
  }

  public valuesOnChange(event: FilterPanelDemoData): void {
    this.dataModelOnChange = event;
    this._observeFormChanges();
    this._patchModel();
  }

  private _observeFormChanges(): void {
    const formGroup = this.dataModelOnChange.formGroup;
    if (formGroup && formGroup.value) {
      this.isSearchButtonEnabled = computed(() => {
        return isModified(formGroup.value);
      });
    }
  }

  private _patchModel(): void {
    if (Object.keys(this.dataModelOnChange.formConfig.model).length === 0) {
      this.dataModelOnChange.formConfig.model = { dto: { division: { project: { organizationalUnit: this._userService.userEntity() } } } };
      this.isSearchButtonEnabled = computed(() => true);
    }
  }

  public onClickFilter(): void {
    console.error('click filter');
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
